<template>
  <div id="info-pane" class="leaflet-bar chart-container absolute top-0 right-0 bg-white p-3 z-1000">
    <scatter-chart :data="initial" :library="options" class="w-64 h-48"></scatter-chart>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this.$parent.$refs.map.points)
    this.$parent.$refs.map.markerCluster.on('load', this.updateChart)
  },
  data() {
    return {
      initial: {
        datasets: [
          {
            label: 'Portland Heritage Trees',
            // the data values are empty at this moment
            // and will be updated dynamically below
            data: [],
          },
        ],
      },
      options: {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'errors',
              },
              ticks: {
                beginAtZero: true,
                max: 20,
                stepSize: 5,
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'volume',
              },
              ticks: {
                beginAtZero: true,
                max: 10000,
                stepSize: 500,
              },
            },
          ],
        },
        maintainAspectRatio: false,
        // turn off animations during chart data updates
        animation: {
          duration: 0,
        },
        // see STEP 4 below
        onHover: this.handleChartHover,
      },
    }
  },
  methods: {
    updateChart() {
      console.log('loaded')
    },
    handleChartHover() {},
  },
}
</script>
